import styled, { css } from 'styled-components'
import { defaultTransition } from '../../../theme'
import { getCardColor, getRemValue, getRgbaValue } from '../../../utils/styling'
import { Box } from '../../UI/Box'

export const DesktopView = styled.div`
  display: none;

  @media screen and (min-width: 1000px) {
    display: unset;
  }
`

export const MobileView = styled.div`
  display: unset;
  width: 100%;

  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const CardsWrapper = styled(Box)``

const imageStyles = css`
  position: absolute;
  top: 0;
  height: 180px;
  width: 290px;
  object-fit: cover;
  border-radius: 2px;
`

export const BlurImage = styled.img`
  ${imageStyles}
  ${defaultTransition}
  z-index: 0;
  opacity: 1;
  border-radius: 2px;
`

export const CardImage = styled.img`
  ${imageStyles}
  z-index: 10;
`

type LiveTimerProps = {
  isLive: boolean
  isTimer?: boolean
  shouldAnimate?: boolean
}

export const Container = styled.div<LiveTimerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 290px;
  min-height: 405px;
  transition: transform 0.15s ease-in-out;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: black;
  overflow: hidden;
  padding: 16px;
  min-height: 458px;
  :hover {
    transform: translateY(-10px);
  }
`

export const TimeLeftBanner = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  width: 92px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.brandPrimary};
  text-align: center;
`

export const ImageContainer = styled.div`
  position: relative;
  height: 180px;
`

export const TimeLeftText = styled.p`
  font-weight: 500;
  font-size: ${getRemValue(11)};
  line-height: 20px;
  text-transform: uppercase;
  font-feature-settings: 'ss01';
  color: ${(props) => props.theme.textSecondary};
  margin: auto 0;
`

export const CoinInfoTag = styled.div<{ marginTop?: string }>`
  display: flex;
  margin-top: ${(props) => props.marginTop};
`

export const CoinLogo = styled.img`
  margin-right: 12px;

  width: 48px;
  height: 48px;
`

export const CoinName = styled.p`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const CoinTicker = styled.p<{ marginTop?: string }>`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: #fff;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  opacity: 0.5;
`

export const ChainIcon = styled.img<{ isSmall?: boolean }>`
  width: ${({ isSmall }) => (isSmall ? '16px' : '30px')};
  height: ${({ isSmall }) => (isSmall ? '16px' : '30px')};
  filter: invert(${({ theme }) => theme.whiteInvert});
`

export const ChainIconWrapper = styled.div`
  margin: auto 0;
  width: 32px;
  height: 32px;
  border: 1px solid
    ${({ theme }) =>
      theme.isDark
        ? getRgbaValue('#ffffff', 0.3)
        : getRgbaValue('#000000', 0.3)};

  border-radius: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DescriptionWrapper = styled.div`
  margin: 10px 0 20px;
  width: 100%;
`

export const DescriptionText = styled.div`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  text-overflow: ellipsis;
  font-family: 'Space Grotesk';
  flex: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px; /* 157.143% */
`

export const StatWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
`

export const StatName = styled.p`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: #fff;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;

  opacity: 0.5;
`

export const StatValue = styled.p`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  text-align: right;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`

export const OpeningLabel = styled(Box)<LiveTimerProps>`
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 20;
  height: 20px;
  left: 26px;
  top: 26px;
  width: auto;
  padding: 2px 8px;
  background: ${getCardColor};
  border-radius: 4px;
  flex: 0;
  span {
    font-family: 'Space Grotesk';
    font-size: 11px;
    line-height: 12px;
    color: ${({ isLive, theme }) => (isLive ? '#00FFA3' : 'black')};
    text-transform: uppercase;
  }
`

export const ProgressContainer = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 20;
  padding: 8px;
  background: linear-gradient(0deg, #000000 20.18%, rgba(0, 0, 0, 0) 96%);
  span.title {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.05em;
    opacity: 0.5;
    margin-bottom: 8px;
    z-index: 20;
    color: #fff;
  }
  span.pct {
    font-family: 'Space Grotesk';
    font-style: normal;
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #f7f8ff;
  }

  span.time-text {
    font-family: 'Space Grotesk';
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0.5;
    margin: 0;
  }

  div.bar {
    flex: 3;
  }
  div.timer {
    flex: 2;
    margin-left: 16px;
    @media screen and (max-width: 1000px) {
      flex: 3;
    }
  }
`
